import MainMenu from './components/Menu/Menu';
import React, { useEffect } from 'react';
import axiosInstance from './lib/auth/axiosApi';
import 'semantic-ui-css/semantic.min.css';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom"
import Login from "./views/Auth/Login/Login";
import Signup from "./views/Auth/Signup/Signup";
import ForgotPassword from "./views/Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "./views/Auth/ResetPassword/ResetPassword";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import { setGod } from './features/god/godSlice'
import { setDarkMode, setDarkModeUserId } from './features/darkMode/darkModeSlice'
import { setAllowedCards } from './features/permissions/permissionsSlice'
import { useDispatch } from 'react-redux'
import {LoadingProvider} from "./context/LoadingContext"
import {CartProvider} from "./context/CartContext"
import BlogListPage from "./views/Blog/BlogListPage"
import BlogDetailPage from "./views/Blog/BlogDetailPage"
import LedgerPage from "./views/Ledger/LedgerPage"
import BackgammonPublicPage from "./views/Backgammon/BackgammonPublicPage"
import FlockoutLanding from "./views/Flockout/FlockoutLanding"
import FlockoutHome from "./views/Flockout/FlockoutHome"
import FlockoutMap from "./views/Flockout/FlockoutMap"
import { FLOCKOUT_HOST } from "./views/Flockout/paths"


function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    async function getGod() {
      try {
        let res = await axiosInstance.get("/god/")
        if(res && res?.data){
          dispatch(setGod({'is_god': res.data.is_god}))
          dispatch(setDarkMode({'dark_mode': res.data.dark_mode}))
          dispatch(setDarkModeUserId({'user_id': res.data.user_id}))
          dispatch(setAllowedCards({'allowed_cards': res.data.allowed_cards || []}))
        }
      } catch (error) {
        console.log('Unable to connect to backend:', error.message)
        // Continue without god data - app should still work
      }
    }
    
    // Only run once on mount
    getGod()
  }, [dispatch])

  return (
    <LoadingProvider>
      <CartProvider>
        <Router>
          <ToastContainer />
          {FLOCKOUT_HOST ? (
            <Switch>
              <Route exact path="/" component={FlockoutHome} />
              <Route path="/about" component={FlockoutLanding} />
              <Route path="/map" component={FlockoutMap} />
              <Route path="/login" component={Login} />
              <Route path="/signup" component={Signup} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/reset-password" component={ResetPassword} />
              <Redirect to="/" />
            </Switch>
          ) : (
          <Switch>
            <Route exact path="/flockout" component={FlockoutHome} />
            <Route path="/flockout/about" component={FlockoutLanding} />
            <Route path="/flockout/map" component={FlockoutMap} />
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Signup} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password" component={ResetPassword} />
            <Route exact path="/blog" component={BlogListPage} />
            <Route path="/blog/:slug" component={BlogDetailPage} />
            <Route exact path="/ledger" component={LedgerPage} />
            <Route exact path="/backgammon" component={BackgammonPublicPage} />
            <PrivateRoute component={MainMenu} />
          </Switch>
          )}
        </Router>
      </CartProvider>
    </LoadingProvider>
  );
}

export default App;
